import { createMuiTheme, ThemeProvider as MaterialThemeProvider } from '@material-ui/core';
import useLanguageStore from '@stores/languageStore';
import React, { useMemo } from 'react';
import overrides from './overrides';

export const ThemeProvider = ({ children }) => {
  const { language } = useLanguageStore();
  const isRtl = language === 'he';

  const theme = useMemo(
    () =>
      createMuiTheme({
        direction: isRtl ? 'rtl' : 'ltr',
        typography: {
          fontFamily: isRtl
            ? '"Assistant", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
            : '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        },
        overrides,
      }),
    [isRtl]
  );

  return <MaterialThemeProvider theme={theme}>{children}</MaterialThemeProvider>;
};
